@use "styles/abstracts/variables" as v;
@use "styles/abstracts/mixins/typography" as t;

.cargo-list-wrap {
  padding: 24px;
  max-height: 114px;
  overflow: auto;
}

.cargo-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  column-gap: 0;
  row-gap: 0;
}

.cargo-list-item {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  padding: 0;
  height: 22px;
}

.cargo-color {
  width: 8px;
  min-width: 8px;
  height: 8px;
  border-radius: 20px;
}

.cargo-name {
  @include t.text(14px, 22px, 600);
  color: #15354e;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  text-transform: capitalize;
}

.cargo-qty {
  @include t.text(14px, 22px, 400);
  color: v.$palette-gray-900;
  white-space: nowrap;

  span:first-child {
    font-weight: 600;
    color: #15354e;
  }
}

.checkbox {
  display: none;
}

@media (max-width: 768px) {
  .cargo-list {
    grid-template-columns: 1fr;
    gap: 8px;
  }

  .cargo-list-wrap {
    padding: 16px;
    max-height: 180px;
  }
}

@media (max-width: 480px) {
  .cargo-list-wrap {
    padding: 12px;
    max-height: 160px;
  }
}
